import {
  handleErrors as onError,
  handleRespondedErrors,
} from './errorHandlers';
import { ApiClient } from '../../types/client.types';
import { camelCased } from './camelCased';
import { snakeCased } from './snakeCased';
import { httpClient } from './httpClient';
import _ from 'lodash';
import { log } from '../log';

export const createApiClient = ({
  baseURL = process.env.API_GATEWAY_URL || '',
  token,
  convert = true,
}: {
  token?: string;
  baseURL?: string;
  convert?: boolean;
} = {}): ApiClient => {
  const config: any = {
    baseURL,
    withCredentials: true,
  };
  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  const apiClient = httpClient.create(config);

  // handle errors responded with 2xx responses.
  apiClient.interceptors.response.use(handleRespondedErrors);

  // extract data on success (only important part).
  apiClient.interceptors.response.use((res) => {
    log.info('Network Response', {
      ...res,
      headers: _.omit(res.headers, 'Authorization'),
    });
    return convert ? camelCased(res.data) : res.data;
  });

  // handle network errors (4xx & 5xx responses).
  apiClient.interceptors.response.use(undefined, onError);

  // Handle both JSON and FormData requests
  apiClient.interceptors.request.use((config) => {
    const isFormData = config.data instanceof FormData;

    return {
      ...config,
      params: convert ? snakeCased(config.params) : config.params,
      // Only convert to snake_case if it's not FormData
      data: convert && !isFormData ? snakeCased(config.data) : config.data,
      headers: {
        ...config.headers,
        // Set proper Content-Type based on data type
        'Content-Type': isFormData
          ? 'multipart/form-data'
          : config.headers['Content-Type'] || 'application/json',
      },
    };
  });

  return apiClient;
};
